import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetUserId,
} from "../../../Utils/Utils";
import { toast } from "react-toastify";
import LinkedINImage from "../../../Assets/linkedin.svg";
import massageicon from "../../../Assets/FrameDiff.svg";
import company from "../../../Assets/people-logo.png";
import education from "../../../Assets/cap-logo.png";
import experience from "../../../Assets/jobcompany.png";
import Siderbardeleteicon from "../../../Assets/Delete.svg";
import "./Style.css";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { ClearIcon } from "@mui/x-date-pickers";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import partnerimg from "../../../Assets/partnerimg.svg";
import { Link } from "react-router-dom";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LabelInput from "../../../Components/LabelInputFields/Index";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Modal,
  Slide,
  Stack,
  Avatar,
  Card,
  CardContent,
  IconButton,
  Typography,
  Chip,
  Divider,
} from "@mui/material";
export default function RightSidebarMobileAiPath({
  dataShortestPath,
  setDataShortestPath,
  sourceuid,
  targetuid,
  getSavedAiPath,
  pathName,
  setPathName,
  editData,
  viewData,
  setViewData,
  setEditData,
  setsourceuid,
  setFromalldata,
  settargetuid,
  setToinput,
  openSidebar,
  setOpenSidebar,
  namePaths,
  searchTask,
}) {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "300px" : "400px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    borderRadius: "8px",
  };
  const initialNodes = dataShortestPath;
  const [isTabletLandscape, setIsTabletLandscape] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonVisiblenew, setbuttonVisiblenew] = useState(false);
  const loggedInUserId = GetUserId();
  const [alternativePath, setAlternativePath] = React.useState([]);
  const [openNameModal, setOpenNameModal] = useState(false);
  const toggleButtonVisibility = () => {
    setButtonVisible(!buttonVisible);
    setbuttonVisiblenew(!buttonVisiblenew);
  };
  function compareNodes(node1, node2) {
    return node1.uid === node2.uid;
  }
  const filterUniqueArrays = (data) => {
    const uniqueArrays = new Set();
    return data.filter((subArray) => {
      const jsonString = JSON.stringify(subArray);
      if (uniqueArrays.has(jsonString)) {
        return false;
      }
      uniqueArrays.add(jsonString);
      return true;
    });
  };
  const handleDeleteNode = (item) => {
    setLoading(true);
    const data = {};
    data.source_uid = dataShortestPath[0]?.source;
    data.target_uid = dataShortestPath[0]?.target;
    const arr = [item?.uid];
    data.nodes_uid = arr;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlTwo()}/v1/remove_node`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setButtonVisible(!buttonVisible);
        if (response?.data[0]?.bestPathInfor?.message !== "Have Path") {
          toast.error("No further paths available");
        }
        if (alternativePath?.length > 0) {
          const data = [...alternativePath, response.data?.[0]];
          const filtered = filterUniqueArrays(data);
          const filterWeighted = filtered.filter((item) => {
            const bestPathNodes = initialNodes?.[0]?.bestPathInfor?.nodes || [];
            const itemNodes = item?.bestPathInfor?.nodes || [];

            if (bestPathNodes.length !== itemNodes.length) return true;

            return !bestPathNodes.every((node, index) =>
              compareNodes(node, itemNodes[index]),
            );
          });
          if (alternativePath?.length == filterWeighted?.length) {
            toast.error("No further paths available");
          }
          setAlternativePath(filterWeighted);
        } else {
          alternativePath.push(response.data?.[0]);
        }
        if (response?.status === 200) {
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error?.response?.data?.message || "No further paths available",
        );
      });
  };

  function combineNodesAndEdges(nodes, edges) {
    const combinedArray = [];
    edges?.forEach((edge) => {
      const sourceNode = nodes?.find((node) => node.uid === edge.source);
      const targetNode = nodes?.find((node) => node.uid === edge.destination);
      if (sourceNode && targetNode) {
        combinedArray?.push({
          ...sourceNode,
          ...edge,
          target: targetNode.uid,
        });
      }
    });
    const lastNode = nodes?.find(
      (node) => !edges.some((edge) => edge.source === node.uid),
    );
    if (lastNode) {
      combinedArray.push(lastNode);
    }
    return combinedArray;
  }

  // AlternativePath
  let addingAlternate = [];
  alternativePath?.forEach((item) => {
    const upcomingAlternate = combineNodesAndEdges(
      item?.bestPathInfor?.nodes,
      item?.bestPathInfor?.edges,
    );
    let updatedAlternate = [];
    let newAlternate = [];
    upcomingAlternate?.forEach((item, index) => {
      updatedAlternate?.push(item);
      if ((index + 1) % 1 === 0 || index === upcomingAlternate?.length - 1) {
        newAlternate?.push(updatedAlternate);
        updatedAlternate = [];
      }
    });
    addingAlternate.push(newAlternate);
  });

  // best path
  const BestPathNodes = combineNodesAndEdges(
    initialNodes?.[0]?.bestPathInfor?.nodes,
    initialNodes?.[0]?.bestPathInfor?.edges,
  );
  const bestPathinnodes = [];

  let tempArray = [];
  BestPathNodes?.forEach((item, index) => {
    tempArray?.push(item);
    if ((index + 1) % 1 === 0 || index === BestPathNodes?.length - 1) {
      bestPathinnodes?.push(tempArray);
      tempArray = [];
    }
  });
  const ShortPathNodes = combineNodesAndEdges(
    initialNodes?.[0]?.shortestPath?.nodes,
    initialNodes?.[0]?.shortestPath?.edges,
  );
  const shortPathinnodes = [];
  let tempArray2 = [];
  ShortPathNodes?.forEach((item, index) => {
    tempArray2?.push(item);
    if ((index + 1) % 1 === 0 || index === ShortPathNodes?.length - 1) {
      shortPathinnodes?.push(tempArray2);
      tempArray2 = [];
    }
  });
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleToPDF = () => {
    const content = componentRef.current;
    const options = {
      filename: "aiPath.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
    };
    html2pdf().set(options).from(content).save();
  };
  const handleSavePath = () => {
    if (pathName?.length < 1) {
      toast.error("Please enter path name");
      return;
    }
    setLoading(true);
    const data = [
      {
        id: 0,
        user_id: Number(loggedInUserId),
        json_result: dataShortestPath,
        path_name: pathName,
        created_dated: new Date(),
        source_id: Number(sourceuid),
        destination_id: Number(targetuid),
      },
    ];
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: JSON.stringify(data),
      url: `${APIUrlThree()}/v1/save_aipath`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setOpenNameModal(false);
        setPathName("");
        setDataShortestPath();
        getSavedAiPath();
        toast.success("Path saved successfully");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const handleUpdatePath = () => {
    if (pathName?.length < 1) {
      toast.error("Please enter path name");
      return;
    }
    setLoading(true);
    const data = {
      id: 0,
      user_id: Number(loggedInUserId),
      json_result: dataShortestPath,
      path_name: pathName,
      created_dated: new Date(),
      source_id: Number(sourceuid),
      destination_id: Number(targetuid),
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: JSON.stringify([data]),
      url: `${APIUrlThree()}/v1/update_aipath?aipathId=${editData?.id}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setOpenNameModal(false);
        setPathName("");
        setDataShortestPath();
        getSavedAiPath();
        setEditData();
        setViewData();
        setsourceuid();
        setFromalldata("");
        settargetuid();
        setToinput("");

        toast.success("Path updated successfully");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)",
    );
    const handleChange = (e) => {
      setIsTabletLandscape(e.matches);
    };
    setIsTabletLandscape(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const [isTabPortrait, setIsTabPortrait] = React.useState(false);
  React.useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );
    const handler = (e) => {
      setIsTabPortrait(e.matches);
    };
    handler(mediaQuery);
    mediaQuery.addEventListener("change", handler);
    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);
  const getInitials = (name) => {
    return name
      ?.split(" ")
      ?.map((n) => n[0])
      ?.join("")
      ?.toUpperCase()
      ?.slice(0, 2);
  };
  return (
    <>
      {searchTask ? (
        <>
          <div
            className="aip-path-btn"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button onClick={toggleButtonVisibility}>
              {buttonVisible
                ? "Disable Alternate Paths"
                : "Enable Alternate Paths"}
            </button>
          </div>
          {initialNodes?.length &&
          initialNodes?.[0]?.message !== "No Path Found" ? (
            <div className="main-container-ofAll-ai-Paths">
              <div className="submain-container">
                <div className="outer-container-of-ai-paths"></div>
                {/* Alternate path  */}
                <div ref={componentRef} className="print-div-full">
                  {addingAlternate
                    .slice()
                    .reverse()
                    .map((myItem, index) => {
                      return myItem?.length ? (
                        <>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              gutterBottom
                              style={{ color: "#7C7C7C", marginTop: "20px" }}
                            >
                              Alternate Path {addingAlternate?.length - index}
                            </Typography>

                            <Stack>
                              {myItem.map((item, index) => (
                                <>
                                  {item?.map((user, idx) => (
                                    <>
                                      <Card
                                        key={index}
                                        variant="outlined"
                                        sx={{
                                          borderRadius: 3,
                                          boxShadow: 1,
                                          my: 0,
                                        }}
                                      >
                                        <CardContent
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            p: 1,
                                          }}
                                        >
                                          <div className="rightsidebar-box-mainouter">
                                            <div className="rightsidebar-box-mainouter-first">
                                              <div className="rightsidebar-box-mainouter-one">
                                                {" "}
                                                <Avatar
                                                  sx={{
                                                    bgcolor: "primary.main",
                                                    mr: 1,
                                                  }}
                                                  style={{
                                                    height: "30px",
                                                    width: "30px",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  {getInitials(user.name)}
                                                </Avatar>
                                              </div>

                                              {/* User Info */}
                                              <div className="rightsidebar-box-mainouter-two">
                                                <Box sx={{ flexGrow: 1 }}>
                                                  <Typography
                                                    variant="subtitle1"
                                                    fontWeight="600"
                                                  >
                                                    {user.name}
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{
                                                      fontSize: 13,
                                                      wordBreak: "break-word",
                                                      whiteSpace: "normal",
                                                    }}
                                                  >
                                                    {user.company}
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    style={{
                                                      wordWrap: "break-word",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {user?.email?.length > 14
                                                        ? user?.email?.slice(
                                                            0,
                                                            14,
                                                          ) + "..."
                                                        : user?.email}
                                                    </Typography>
                                                  </Typography>
                                                  <Link
                                                    href={user?.linkedin}
                                                    target="_blank"
                                                    style={{
                                                      fontSize: "12px",
                                                      display: "block",
                                                      color: "#0004FF",
                                                    }}
                                                    sx={{
                                                      fontSize: 12,
                                                      display: "block",
                                                      color: "#0004FF",
                                                    }}
                                                  >
                                                    {user?.linkedin
                                                      ?.split("/")
                                                      .pop()}
                                                  </Link>
                                                </Box>
                                              </div>
                                            </div>
                                            {/* Email Button */}
                                            <div className="rightsidebar-box-mainouter-three">
                                              {buttonVisible &&
                                                !(index === 0) &&
                                                !(
                                                  index ===
                                                  bestPathinnodes?.length - 1
                                                ) && (
                                                  <div className="">
                                                    <button
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                      className="DeleteButtonVisible-mobile"
                                                      onClick={() =>
                                                        handleDeleteNode(user)
                                                      }
                                                    >
                                                      <img
                                                        src={Siderbardeleteicon}
                                                        alt=""
                                                      />
                                                    </button>
                                                  </div>
                                                )}

                                              <IconButton
                                                component="a"
                                                href={`mailto:${user?.email}`}
                                                color="error"
                                                className="aip-email"
                                              >
                                                <EmailOutlinedIcon />
                                              </IconButton>
                                            </div>
                                          </div>
                                        </CardContent>
                                      </Card>
                                      {user.weight && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            my: 0,
                                          }}
                                        >
                                          <Chip
                                            label={user.weight}
                                            variant="outlined"
                                            sx={{
                                              borderRadius: 2,
                                              fontWeight: "bold",
                                              margin: "10px",
                                            }}
                                          />
                                          <span className="aip-mb-path"></span>
                                          <div className="aip-mb-relation">
                                            {user?.relation && (
                                              <div className="siderbar-image-container-right-sidebar">
                                                <div className="Siderbar-lits-images">
                                                  {user?.relation?.includes(
                                                    "Email",
                                                  ) && (
                                                    <img
                                                      src={massageicon}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "LinkedIn",
                                                  ) && (
                                                    <img
                                                      src={LinkedINImage}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "Organization",
                                                  ) && (
                                                    <img
                                                      src={company}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "Education",
                                                  ) && (
                                                    <img
                                                      src={education}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "Experience",
                                                  ) && (
                                                    <img
                                                      src={experience}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "Meeting",
                                                  ) && (
                                                    <CalendarMonthIcon className="siderbar-modal-img" />
                                                  )}
                                                  {user?.relation?.includes(
                                                    "Partner",
                                                  ) && (
                                                    <img
                                                      src={partnerimg}
                                                      alt=""
                                                      className="siderbar-modal-img"
                                                    />
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                            {/* {buttonVisible &&
                                              !(index === 0) &&
                                              !(
                                                index ===
                                                myItem?.length - 1
                                              ) && (
                                                <div className="">
                                                  <button
                                                    style={{
                                                      fontSize: "14px",
                                                    }}
                                                    className="DeleteButtonVisible"
                                                    onClick={() =>
                                                      handleDeleteNode(user)
                                                    }
                                                  >
                                                    <img
                                                      src={Siderbardeleteicon}
                                                      alt=""
                                                    />
                                                    Remove
                                                  </button>
                                                </div>
                                              )} */}
                                          </div>
                                        </Box>
                                      )}
                                    </>
                                  ))}
                                </>
                              ))}
                            </Stack>
                          </Box>
                        </>
                      ) : null;
                    })}
                  {addingAlternate?.length ? (
                    <Divider className="divider-for-seperator-section" />
                  ) : null}
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                      style={{ color: "#7C7C7C", marginTop: "10px" }}
                    >
                      Weighted Path
                    </Typography>

                    <Stack>
                      {bestPathinnodes.map((item, index) => (
                        <>
                          {item?.map((user, idx) => (
                            <>
                              <Card
                                key={index}
                                variant="outlined"
                                sx={{ borderRadius: 3, boxShadow: 1, my: 0 }}
                              >
                                <CardContent
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    p: 1,
                                  }}
                                >
                                  <div className="rightsidebar-box-mainouter">
                                    <div className="rightsidebar-box-mainouter-first">
                                      <div className="rightsidebar-box-mainouter-one">
                                        <Avatar
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                            fontSize: "12px",
                                          }}
                                          sx={{
                                            bgcolor: "primary.main",
                                            mr: 1,
                                          }}
                                        >
                                          {getInitials(user.name)}
                                        </Avatar>
                                      </div>
                                      <div className="rightsidebar-box-mainouter-two">
                                        <Box sx={{ flexGrow: 1 }}>
                                          <Typography
                                            variant="subtitle1"
                                            fontWeight="600"
                                          >
                                            {user.name}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                              fontSize: 13,
                                              wordBreak: "break-word",
                                              whiteSpace: "normal",
                                            }}
                                          >
                                            {user.company}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ fontSize: 12 }}
                                            style={{ wordWrap: "break-word" }}
                                          >
                                            {user?.email?.length > 14
                                              ? user?.email?.slice(0, 14) +
                                                "..."
                                              : user?.email}{" "}
                                          </Typography>
                                          <Link
                                            style={{
                                              fontSize: "12px",
                                              display: "block",
                                              color: "#0004FF",
                                            }}
                                            href={user?.linkedin}
                                            target="_blank"
                                            sx={{
                                              fontSize: 12,
                                              display: "block",
                                              color: "#0004FF",
                                            }}
                                          >
                                            {user.linkedin?.split("/").pop()}
                                          </Link>
                                        </Box>
                                      </div>
                                    </div>
                                    <div className="rightsidebar-box-mainouter-three">
                                      {buttonVisible &&
                                        !(index === 0) &&
                                        !(
                                          index ===
                                          bestPathinnodes?.length - 1
                                        ) && (
                                          <div className="">
                                            <button
                                              style={{ fontSize: "14px" }}
                                              className="DeleteButtonVisible-mobile"
                                              onClick={() =>
                                                handleDeleteNode(user)
                                              }
                                            >
                                              <img
                                                src={Siderbardeleteicon}
                                                alt=""
                                              />
                                            </button>
                                          </div>
                                        )}

                                      <IconButton
                                        component="a"
                                        href={`mailto:${user?.email}`}
                                        color="error"
                                        className="aip-email"
                                      >
                                        <EmailOutlinedIcon />
                                      </IconButton>
                                    </div>
                                  </div>
                                </CardContent>

                                {/* Bottom Score Badge */}
                              </Card>
                              {user.weight && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    my: 0,
                                  }}
                                >
                                  <Chip
                                    label={user.weight}
                                    variant="outlined"
                                    sx={{
                                      borderRadius: 2,
                                      fontWeight: "bold",
                                      margin: "10px",
                                    }}
                                  />
                                  <span className="aip-mb-path"></span>
                                  <div className="aip-mb-relation">
                                    {user?.relation && (
                                      <div className="siderbar-image-container-right-sidebar">
                                        <div className="Siderbar-lits-images">
                                          {user?.relation?.includes(
                                            "Email",
                                          ) && (
                                            <img
                                              src={massageicon}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "LinkedIn",
                                          ) && (
                                            <img
                                              src={LinkedINImage}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Organization",
                                          ) && (
                                            <img
                                              src={company}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Education",
                                          ) && (
                                            <img
                                              src={education}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Experience",
                                          ) && (
                                            <img
                                              src={experience}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Meeting",
                                          ) && (
                                            <CalendarMonthIcon className="siderbar-modal-img" />
                                          )}
                                          {user?.relation?.includes(
                                            "Partner",
                                          ) && (
                                            <img
                                              src={partnerimg}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {/* {buttonVisible &&
                                      !(index === 0) &&
                                      !(
                                        index ===
                                        bestPathinnodes?.length - 1
                                      ) && (
                                        <div className="">
                                          <button
                                            style={{ fontSize: "14px" }}
                                            className="DeleteButtonVisible"
                                            onClick={() =>
                                              handleDeleteNode(user)
                                            }
                                          >
                                            <img
                                              src={Siderbardeleteicon}
                                              alt=""
                                            />
                                            Remove
                                          </button>
                                        </div>
                                      )} */}
                                  </div>
                                </Box>
                              )}
                            </>
                          ))}
                        </>
                      ))}
                    </Stack>
                  </Box>
                  {bestPathinnodes?.length ? (
                    <Divider className="divider-for-seperator-section" />
                  ) : null}
                  {/* Shortest path */}
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                      style={{ color: "#7C7C7C", marginTop: "20px" }}
                    >
                      Simple Path
                    </Typography>

                    <Stack>
                      {shortPathinnodes.map((item, index) => (
                        <>
                          {item?.map((user, idx) => (
                            <>
                              <Card
                                key={index}
                                variant="outlined"
                                sx={{ borderRadius: 3, boxShadow: 1, my: 0 }}
                              >
                                <CardContent
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    p: 1,
                                  }}
                                >
                                  {/* Avatar */}
                                  <div className="rightsidebar-box-mainouter">
                                    <div className="rightsidebar-box-mainouter-first">
                                      <div className="rightsidebar-box-mainouter-one">
                                        <Avatar
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                            fontSize: "12px",
                                          }}
                                          sx={{
                                            bgcolor: "primary.main",
                                            mr: 1,
                                          }}
                                        >
                                          {getInitials(user.name)}
                                        </Avatar>
                                      </div>

                                      {/* User Info */}
                                      <div className="rightsidebar-box-mainouter-two">
                                        <Box sx={{ flexGrow: 1 }}>
                                          <Typography
                                            variant="subtitle1"
                                            fontWeight="600"
                                          >
                                            {user.name}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                              fontSize: 13,
                                              wordBreak: "break-word", // breaks long strings
                                              whiteSpace: "normal",
                                            }}
                                          >
                                            {user.company}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ fontSize: 12 }}
                                            style={{ wordWrap: "break-word" }}
                                          >
                                            {user?.email?.length > 14
                                              ? user?.email.slice(0, 14) + "..."
                                              : user?.email}{" "}
                                          </Typography>
                                          <Link
                                            style={{
                                              fontSize: "12px",
                                              display: "block",
                                              color: "#0004FF",
                                            }}
                                            href={user?.linkedin}
                                            target="_blank"
                                            // underline="hover"
                                            sx={{
                                              fontSize: 12,
                                              display: "block",
                                              color: "#0004FF",
                                            }}
                                          >
                                            {user.linkedin?.split("/").pop()}
                                          </Link>
                                        </Box>
                                      </div>
                                    </div>
                                    {/* Email Button */}
                                    <div className="rightsidebar-box-mainouter-three">
                                      <IconButton
                                        component="a"
                                        href={`mailto:${user?.email}`}
                                        color="error"
                                        className="aip-email"
                                      >
                                        <EmailOutlinedIcon />
                                      </IconButton>
                                    </div>
                                  </div>
                                </CardContent>

                                {/* Bottom Score Badge */}
                              </Card>
                              {user.weight && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    my: 0,
                                  }}
                                >
                                  <Chip
                                    label={user.weight}
                                    variant="outlined"
                                    sx={{
                                      borderRadius: 2,
                                      fontWeight: "bold",
                                      margin: "10px",
                                    }}
                                  />
                                  <span className="aip-mb-path"></span>
                                  {user?.relation && (
                                    <div className="aip-mb-relation">
                                      <div className="siderbar-image-container-right-sidebar">
                                        <div className="Siderbar-lits-images">
                                          {user?.relation?.includes(
                                            "Email",
                                          ) && (
                                            <img
                                              src={massageicon}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "LinkedIn",
                                          ) && (
                                            <img
                                              src={LinkedINImage}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Organization",
                                          ) && (
                                            <img
                                              src={company}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Education",
                                          ) && (
                                            <img
                                              src={education}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Experience",
                                          ) && (
                                            <img
                                              src={experience}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                          {user?.relation?.includes(
                                            "Meeting",
                                          ) && (
                                            <CalendarMonthIcon className="siderbar-modal-img" />
                                          )}
                                          {user?.relation?.includes(
                                            "Partner",
                                          ) && (
                                            <img
                                              src={partnerimg}
                                              alt=""
                                              className="siderbar-modal-img"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Box>
                              )}
                            </>
                          ))}
                        </>
                      ))}
                    </Stack>
                  </Box>
                </div>
                <p className="ai-path-table-btn">
                  {viewData ? (
                    <Button
                      variant="text"
                      className="save-btn-aipath-table"
                      onClick={() => {
                        setDataShortestPath([]);
                        setViewData();
                        setEditData();
                      }}
                    >
                      Cancel
                    </Button>
                  ) : (
                    <Button
                      variant="text"
                      className="cancel-btn-aipath-tables"
                      onClick={() => {
                        setDataShortestPath([]);
                        setEditData();
                        setViewData();
                        setEditData();
                        setViewData();
                        setsourceuid();
                        setFromalldata("");
                        settargetuid();
                        setToinput("");
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                  {viewData ? null : editData ? (
                    <Button
                      variant="text"
                      className="save-btn-aipath-table"
                      onClick={() => setOpenNameModal(true)}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      variant="text"
                      className="save-btn-aipath-table"
                      onClick={() => setOpenNameModal(true)}
                    >
                      Save
                    </Button>
                  )}
                </p>
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <Slide
          direction="left"
          in={openSidebar}
          mountOnEnter
          unmountOnExit
          className= {isPortrait ? "aip-filter-mb-slide-portrait" : "aip-filter-mb-slide"}
          style={{ paddingBottom: "70px" }}
        >
          <Box
            sx={{
              position: "fixed",
              top: isTabPortrait ? "33px" : "0",
              left: isTabPortrait ? "" : "0",
              width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
              right: isTabPortrait ? "0px" : "",
              height: "100vh",
              bgcolor: "white",
              zIndex: 10,
              boxShadow: 2,
              display: "flex",
              flexDirection: "column",
              overflowX: "hidden",
              overflowY: "auto",
            pb: 20,

            }}
          >
            <>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ backgroundColor: "#f3f4f9" }}
                py={1.5}
              >
                <>
                  <IconButton
                    onClick={() => {
                      setOpenSidebar(false);
                      setDataShortestPath([]);
                      setEditData();
                      setViewData();
                      setEditData();
                      setViewData();
                      setsourceuid();
                      setFromalldata("");
                      settargetuid();
                      setToinput("");
                      setAlternativePath([]);
                      setButtonVisible(false);
                    }}
                  ></IconButton>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    style={{ textTransform: "capitalize" }}
                  >
                    {namePaths}
                  </Typography>
                  <IconButton
                    onClick={() => {
                      setOpenSidebar(false);
                      setDataShortestPath([]);
                      setEditData();
                      setViewData();
                      setEditData();
                      setViewData();
                      setsourceuid();
                      setFromalldata("");
                      settargetuid();
                      setToinput("");
                      setAlternativePath([]);
                      setButtonVisible(false);
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </>
              </Box>
              <div
                className="aip-path-btn"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <button onClick={toggleButtonVisibility}>
                  {buttonVisible
                    ? "Disable Alternate Paths"
                    : "Enable Alternate Paths"}
                </button>
              </div>
              {initialNodes?.length &&
              initialNodes?.[0]?.message !== "No Path Found" ? (
                <div className="main-container-ofAll-ai-Paths">
                  <div className="submain-container">
                    <div className="outer-container-of-ai-paths"></div>
                    {/* Alternate path  */}
                    <div ref={componentRef} className="print-div-full">
                      {addingAlternate
                        .slice()
                        .reverse()
                        .map((myItem, index) => {
                          return myItem?.length ? (
                            <>
                              <Box>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                  gutterBottom
                                  style={{
                                    color: "#7C7C7C",
                                    marginTop: "20px",
                                  }}
                                >
                                  Alternate Path{" "}
                                  {addingAlternate?.length - index}
                                </Typography>

                                <Stack>
                                  {myItem.map((item, index) => (
                                    <>
                                      {item?.map((user, idx) => (
                                        <>
                                          <Card
                                            key={index}
                                            variant="outlined"
                                            sx={{
                                              borderRadius: 3,
                                              boxShadow: 1,
                                              my: 0,
                                            }}
                                          >
                                            <CardContent
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                p: 1,
                                              }}
                                            >
                                              <div className="rightsidebar-box-mainouter">
                                                <div className="rightsidebar-box-mainouter-first">
                                                  <div className="rightsidebar-box-mainouter-one">
                                                    {" "}
                                                    <Avatar
                                                      style={{
                                                        height: "30px",
                                                        width: "30px",
                                                        fontSize: "12px",
                                                      }}
                                                      sx={{
                                                        bgcolor: "primary.main",
                                                        mr: 1,
                                                      }}
                                                    >
                                                      {getInitials(user.name)}
                                                    </Avatar>
                                                  </div>

                                                  {/* User Info */}
                                                  <div className="rightsidebar-box-mainouter-two">
                                                    <Box sx={{ flexGrow: 1 }}>
                                                      <Typography
                                                        variant="subtitle1"
                                                        fontWeight="600"
                                                      >
                                                        {user.name}
                                                      </Typography>
                                                      <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        sx={{
                                                          fontSize: 13,
                                                          wordBreak:
                                                            "break-word",
                                                          whiteSpace: "normal",
                                                        }}
                                                      >
                                                        {user.company}
                                                      </Typography>
                                                      <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        sx={{ fontSize: 12 }}
                                                        style={{
                                                          wordWrap:
                                                            "break-word",
                                                        }}
                                                      >
                                                        <Typography
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          {" "}
                                                          {user?.email?.length >
                                                          14
                                                            ? user?.email?.slice(
                                                                0,
                                                                14,
                                                              ) + "..."
                                                            : user?.email}
                                                        </Typography>
                                                      </Typography>
                                                      <Link
                                                        style={{
                                                          fontSize: "12px",
                                                          display: "block",
                                                          color: "#0004FF",
                                                        }}
                                                        href={user?.linkedin}
                                                        target="_blank"
                                                        sx={{
                                                          fontSize: 12,
                                                          display: "block",
                                                          color: "#0004FF",
                                                        }}
                                                      >
                                                        {user?.linkedin
                                                          ?.split("/")
                                                          .pop()}
                                                      </Link>
                                                    </Box>
                                                  </div>
                                                </div>
                                                {/* Email Button */}
                                                {/* <div className="rightsidebar-box-mainouter-three">
                                                  <IconButton
                                                    color="error"
                                                    className="aip-email"
                                                  >
                                                    <EmailOutlinedIcon />
                                                  </IconButton>
                                                </div> */}
                                                <div className="rightsidebar-box-mainouter-three">
                                                  {buttonVisible &&
                                                    !(index === 0) &&
                                                    !(
                                                      index ===
                                                      bestPathinnodes?.length -
                                                        1
                                                    ) && (
                                                      <div className="">
                                                        <button
                                                          style={{
                                                            fontSize: "14px",
                                                          }}
                                                          className="DeleteButtonVisible-mobile"
                                                          onClick={() =>
                                                            handleDeleteNode(
                                                              user,
                                                            )
                                                          }
                                                        >
                                                          <img
                                                            src={
                                                              Siderbardeleteicon
                                                            }
                                                            alt=""
                                                          />
                                                        </button>
                                                      </div>
                                                    )}

                                                  <IconButton
                                                    component="a"
                                                    href={`mailto:${user?.email}`}
                                                    color="error"
                                                    className="aip-email"
                                                  >
                                                    <EmailOutlinedIcon />
                                                  </IconButton>
                                                </div>
                                              </div>
                                            </CardContent>
                                          </Card>
                                          {user.weight && (
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                my: 0,
                                              }}
                                            >
                                              <Chip
                                                label={user.weight}
                                                variant="outlined"
                                                sx={{
                                                  borderRadius: 2,
                                                  fontWeight: "bold",
                                                  margin: "10px",
                                                }}
                                              />
                                              <span className="aip-mb-path"></span>
                                              <div className="aip-mb-relation">
                                                {user?.relation && (
                                                  <div className="siderbar-image-container-right-sidebar">
                                                    <div className="Siderbar-lits-images">
                                                      {user?.relation?.includes(
                                                        "Email",
                                                      ) && (
                                                        <img
                                                          src={massageicon}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "LinkedIn",
                                                      ) && (
                                                        <img
                                                          src={LinkedINImage}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "Organization",
                                                      ) && (
                                                        <img
                                                          src={company}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "Education",
                                                      ) && (
                                                        <img
                                                          src={education}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "Experience",
                                                      ) && (
                                                        <img
                                                          src={experience}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "Meeting",
                                                      ) && (
                                                        <CalendarMonthIcon className="siderbar-modal-img" />
                                                      )}
                                                      {user?.relation?.includes(
                                                        "Partner",
                                                      ) && (
                                                        <img
                                                          src={partnerimg}
                                                          alt=""
                                                          className="siderbar-modal-img"
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                                {/* {buttonVisible &&
                                                  !(index === 0) &&
                                                  !(
                                                    index ===
                                                    myItem?.length - 1
                                                  ) && (
                                                    <div className="">
                                                      <button
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                        className="DeleteButtonVisible"
                                                        onClick={() =>
                                                          handleDeleteNode(user)
                                                        }
                                                      >
                                                        <img
                                                          src={
                                                            Siderbardeleteicon
                                                          }
                                                          alt=""
                                                        />
                                                        Remove
                                                      </button>
                                                    </div>
                                                  )} */}
                                              </div>
                                            </Box>
                                          )}
                                        </>
                                      ))}
                                    </>
                                  ))}
                                </Stack>
                              </Box>
                            </>
                          ) : null;
                        })}
                      {addingAlternate?.length ? (
                        <Divider className="divider-for-seperator-section" />
                      ) : null}
                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          gutterBottom
                          style={{ color: "#7C7C7C", marginTop: "10px" }}
                        >
                          Weighted Path
                        </Typography>

                        <Stack>
                          {bestPathinnodes.map((item, index) => (
                            <>
                              {item?.map((user, idx) => (
                                <>
                                  <Card
                                    key={index}
                                    variant="outlined"
                                    sx={{
                                      borderRadius: 3,
                                      boxShadow: 1,
                                      my: 0,
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        p: 1,
                                      }}
                                    >
                                      <div className="rightsidebar-box-mainouter">
                                        <div className="rightsidebar-box-mainouter-first">
                                          <div className="rightsidebar-box-mainouter-one">
                                            <Avatar
                                              style={{
                                                height: "30px",
                                                width: "30px",
                                                fontSize: "12px",
                                              }}
                                              sx={{
                                                bgcolor: "primary.main",
                                                mr: 1,
                                              }}
                                            >
                                              {getInitials(user.name)}
                                            </Avatar>
                                          </div>
                                          <div className="rightsidebar-box-mainouter-two">
                                            <Box sx={{ flexGrow: 1 }}>
                                              <Typography
                                                variant="subtitle1"
                                                fontWeight="600"
                                              >
                                                {user.name}
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                  fontSize: 13,
                                                  wordBreak: "break-word",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                {user.company}
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{ fontSize: 12 }}
                                                style={{
                                                  wordWrap: "break-word",
                                                }}
                                              >
                                                {user?.email?.length > 14
                                                  ? user?.email?.slice(0, 14) +
                                                    "..."
                                                  : user?.email}{" "}
                                              </Typography>
                                              <Link
                                                style={{
                                                  fontSize: "12px",
                                                  display: "block",
                                                  color: "#0004FF",
                                                }}
                                                href={user?.linkedin}
                                                target="_blank"
                                                sx={{
                                                  fontSize: 12,
                                                  display: "block",
                                                  color: "#0004FF",
                                                }}
                                              >
                                                {user.linkedin
                                                  ?.split("/")
                                                  .pop()}
                                              </Link>
                                            </Box>
                                          </div>
                                        </div>
                                        {/* <div className="rightsidebar-box-mainouter-three">
                                          <IconButton
                                            color="error"
                                            className="aip-email"
                                          >
                                            <EmailOutlinedIcon />
                                          </IconButton>
                                        </div>{" "} */}
                                        <div className="rightsidebar-box-mainouter-three">
                                          {buttonVisible &&
                                            !(index === 0) &&
                                            !(
                                              index ===
                                              bestPathinnodes?.length - 1
                                            ) && (
                                              <div className="">
                                                <button
                                                  style={{ fontSize: "14px" }}
                                                  className="DeleteButtonVisible-mobile"
                                                  onClick={() =>
                                                    handleDeleteNode(user)
                                                  }
                                                >
                                                  <img
                                                    src={Siderbardeleteicon}
                                                    alt=""
                                                  />
                                                </button>
                                              </div>
                                            )}

                                          <IconButton
                                            component="a"
                                            href={`mailto:${user?.email}`}
                                            color="error"
                                            className="aip-email"
                                          >
                                            <EmailOutlinedIcon />
                                          </IconButton>
                                        </div>
                                      </div>
                                    </CardContent>

                                    {/* Bottom Score Badge */}
                                  </Card>
                                  {user.weight && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        my: 0,
                                      }}
                                    >
                                      <Chip
                                        label={user.weight}
                                        variant="outlined"
                                        sx={{
                                          borderRadius: 2,
                                          fontWeight: "bold",
                                          margin: "10px",
                                        }}
                                      />
                                      <span className="aip-mb-path"></span>
                                      <div className="aip-mb-relation">
                                        {user?.relation && (
                                          <div className="siderbar-image-container-right-sidebar">
                                            <div className="Siderbar-lits-images">
                                              {user?.relation?.includes(
                                                "Email",
                                              ) && (
                                                <img
                                                  src={massageicon}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "LinkedIn",
                                              ) && (
                                                <img
                                                  src={LinkedINImage}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Organization",
                                              ) && (
                                                <img
                                                  src={company}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Education",
                                              ) && (
                                                <img
                                                  src={education}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Experience",
                                              ) && (
                                                <img
                                                  src={experience}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Meeting",
                                              ) && (
                                                <CalendarMonthIcon className="siderbar-modal-img" />
                                              )}
                                              {user?.relation?.includes(
                                                "Partner",
                                              ) && (
                                                <img
                                                  src={partnerimg}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        )}
                                        {/* {buttonVisible &&
                                          !(index === 0) &&
                                          !(
                                            index ===
                                            bestPathinnodes?.length - 1
                                          ) && (
                                            <div className="">
                                              <button
                                                style={{ fontSize: "14px" }}
                                                className="DeleteButtonVisible"
                                                onClick={() =>
                                                  handleDeleteNode(user)
                                                }
                                              >
                                                <img
                                                  src={Siderbardeleteicon}
                                                  alt=""
                                                />
                                                Remove
                                              </button>
                                            </div>
                                          )} */}
                                      </div>
                                    </Box>
                                  )}
                                </>
                              ))}
                            </>
                          ))}
                        </Stack>
                      </Box>
                      {bestPathinnodes?.length ? (
                        <Divider className="divider-for-seperator-section" />
                      ) : null}
                      {/* Shortest path */}
                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          gutterBottom
                          style={{ color: "#7C7C7C", marginTop: "20px" }}
                        >
                          Simple Path
                        </Typography>

                        <Stack>
                          {shortPathinnodes.map((item, index) => (
                            <>
                              {item?.map((user, idx) => (
                                <>
                                  <Card
                                    key={index}
                                    variant="outlined"
                                    sx={{
                                      borderRadius: 3,
                                      boxShadow: 1,
                                      my: 0,
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        p: 1,
                                      }}
                                    >
                                      {/* Avatar */}
                                      <div className="rightsidebar-box-mainouter">
                                        <div className="rightsidebar-box-mainouter-first">
                                          <div className="rightsidebar-box-mainouter-one">
                                            <Avatar
                                              style={{
                                                height: "30px",
                                                width: "30px",
                                                fontSize: "12px",
                                              }}
                                              sx={{
                                                bgcolor: "primary.main",
                                                mr: 1,
                                              }}
                                            >
                                              {getInitials(user.name)}
                                            </Avatar>
                                          </div>

                                          {/* User Info */}
                                          <div className="rightsidebar-box-mainouter-two">
                                            <Box sx={{ flexGrow: 1 }}>
                                              <Typography
                                                variant="subtitle1"
                                                fontWeight="600"
                                              >
                                                {user.name}
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                  fontSize: 13,
                                                  wordBreak: "break-word", // breaks long strings
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                {user.company}
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{ fontSize: 12 }}
                                                style={{
                                                  wordWrap: "break-word",
                                                }}
                                              >
                                                {user?.email?.length > 14
                                                  ? user?.email.slice(0, 14) +
                                                    "..."
                                                  : user?.email}{" "}
                                              </Typography>
                                              <Link
                                                style={{
                                                  fontSize: "12px",
                                                  display: "block",
                                                  color: "#0004FF",
                                                }}
                                                href={user?.linkedin}
                                                target="_blank"
                                                // underline="hover"
                                                sx={{
                                                  fontSize: 12,
                                                  display: "block",
                                                  color: "#0004FF",
                                                }}
                                              >
                                                {user.linkedin
                                                  ?.split("/")
                                                  .pop()}
                                              </Link>
                                            </Box>
                                          </div>
                                        </div>
                                        {/* Email Button */}
                                        <div className="rightsidebar-box-mainouter-three">
                                          <IconButton
                                            component="a"
                                            href={`mailto:${user?.email}`}
                                            color="error"
                                            className="aip-email"
                                          >
                                            <EmailOutlinedIcon />
                                          </IconButton>
                                        </div>
                                      </div>
                                    </CardContent>

                                    {/* Bottom Score Badge */}
                                  </Card>
                                  {user.weight && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        my: 0,
                                      }}
                                    >
                                      <Chip
                                        label={user.weight}
                                        variant="outlined"
                                        sx={{
                                          borderRadius: 2,
                                          fontWeight: "bold",
                                          margin: "10px",
                                        }}
                                      />
                                      <span className="aip-mb-path"></span>
                                      {user?.relation && (
                                        <div className="aip-mb-relation">
                                          <div className="siderbar-image-container-right-sidebar">
                                            <div className="Siderbar-lits-images">
                                              {user?.relation?.includes(
                                                "Email",
                                              ) && (
                                                <img
                                                  src={massageicon}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "LinkedIn",
                                              ) && (
                                                <img
                                                  src={LinkedINImage}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Organization",
                                              ) && (
                                                <img
                                                  src={company}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Education",
                                              ) && (
                                                <img
                                                  src={education}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Experience",
                                              ) && (
                                                <img
                                                  src={experience}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                              {user?.relation?.includes(
                                                "Meeting",
                                              ) && (
                                                <CalendarMonthIcon className="siderbar-modal-img" />
                                              )}
                                              {user?.relation?.includes(
                                                "Partner",
                                              ) && (
                                                <img
                                                  src={partnerimg}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Box>
                                  )}
                                </>
                              ))}
                            </>
                          ))}
                        </Stack>
                      </Box>
                    </div>
                    <p className="ai-path-table-btn">
                      {viewData ? (
                        <Button
                          variant="text"
                          className="save-btn-aipath-table"
                          onClick={() => {
                            setDataShortestPath([]);
                            setViewData();
                            setEditData();
                          }}
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Button
                          variant="text"
                          className="cancel-btn-aipath-tables"
                          onClick={() => {
                            setDataShortestPath([]);
                            setEditData();
                            setViewData();
                            setEditData();
                            setViewData();
                            setsourceuid();
                            setFromalldata("");
                            settargetuid();
                            setToinput("");
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                      {viewData ? null : editData ? (
                        <Button
                          variant="text"
                          className="save-btn-aipath-table"
                          onClick={() => setOpenNameModal(true)}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          variant="text"
                          className="save-btn-aipath-table"
                          onClick={() => setOpenNameModal(true)}
                        >
                          Save
                        </Button>
                      )}
                    </p>
                  </div>
                </div>
              ) : null}
            </>
          </Box>
        </Slide>
      )}
      <Modal
        open={openNameModal}
        onClose={() => setOpenNameModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style}>
            <div className="modal-head-heading-crossicon">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                className="enetr-name-heading-modal"
                
              >
                Enter Path name
              </Typography>
              <ClearIcon
                style={{ cursor: "pointer" }}
                onClick={() => setOpenNameModal(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <label htmlFor="" className="search-name-label-modal">
                AI Path Name
              </label>
              <LabelInput
                value={pathName}
                onChange={(e) => setPathName(e?.target?.value)}
              />
            </Typography>
            <Stack>
              <div className="button-cancel-save-modal" style={{paddingTop:"10px"}}>
                <Button
                  variant="type"
                  className="cancel-button-modal"
                  onClick={() => {
                    setOpenNameModal(false);
                    setPathName("");
                    setDataShortestPath();
                    setEditData();
                    setViewData();
                    setsourceuid();
                    setFromalldata("");
                    settargetuid();
                    setToinput("");
                  }}
                >
                  Cancel
                </Button>
                {editData ? (
                  <Button
                    variant="type"
                    className={
                      pathName?.length > 1
                        ? "save-button-modal"
                        : "save-button-modalclass"
                    }
                    onClick={handleUpdatePath}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    variant="type"
                    className={
                      pathName?.length > 1
                        ? "save-button-modal"
                        : "save-button-modalclass"
                    }
                    onClick={handleSavePath}
                  >
                    Save
                  </Button>
                )}
              </div>
            </Stack>
          </Box>
        </div>
      </Modal>
    </>
  );
}
